import type { FaireProductEntity } from "../../entity_types/product";

export const p_jdjus8jffe: FaireProductEntity = {
  token: "p_jdjus8jffe",
  type: "product",
  name: "Magnesium Oil Roll On with Essential Oils",
  brandToken: "b_6qmzxvyma9",
  brandName: "Wild Roots Tallow Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/366dc8bf464be8af1092e4cb2aa98fe3eaccce909d2a52f1350ceb76e609ac61.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/95153cb42372295ef548ecccf2df95b4983750bb73d6de3dbee5aeccdd0a32a1.jpeg",
    "https://cdn.faire.com/fastly/d4b20ef46985d16c3e4a91bbe9f87aa9db078a52848ccbc36cda5b20031c79ad.jpeg",
    "https://cdn.faire.com/fastly/146099104bfe2efeea093d691e96b302ee29dbd11b2fe082cee7dbd530c6fc9e.jpeg",
    "https://cdn.faire.com/fastly/156d8e6e7840d4c4a3db9e191c1c6ae85caf264633edbbc3160a62424be9c90c.jpeg",
    "https://cdn.faire.com/fastly/c18bb3e023b826d5e2e7e3658551eee77c6d25d77468b180fa0b03a8a0dc10fb.png",
    "https://cdn.faire.com/fastly/9d6a130d1ae972cbfda13932ff7ee80500e10b35963e2efc3ce5cde6a4bf7d28.png",
    "https://cdn.faire.com/fastly/34655d7587e66caa20f0298a575444c510a29615302144df1d101a1883f84ca7.png",
  ],
  priceDollars: 9.7,
  description:
    "Magnesium Oil has a calming effect on the nervous system, helping to reduce stress and anxiety by promoting relaxation. It can also balance cortisol, the body’s primary stress hormone. Excessive cortisol can lead to anxiety and disrupted sleep.\n\nEase - A blend of essential oils and magnesium to help relieve tension and headaches.Peppermint Oil can help soothe migraines and tension headaches. Studies have found that lemongrass oil can be helpful when it comes to soothing headache pain.\n\nDeep Sea Magnesium Oil, Cold Presses Jojoba Oil, Mentha Piperita (Peppermint) Oil Peppermint, Cananga Odorata (Ylang Ylang) Flower Oil, Cymbopogon Flexuosus (Lemongrass) Leaf Oil\n\nRelax - A blend of essential oils and magnesium to help relieve stess and promote relaxation. Lavender can help promote a calm, peaceful, yet tranquil atmosphere helping to relive stress and promote relaxation. Bergamot cuts through negative emotions, like irritation and grief, while providing an uplifting sense of well-being. It can help relax nervous tension and even help calm digestive upsets triggered by stress.\n\nDeep Sea Magnesium Oil, Cold Pressed Jojoba Oil, Lavandula Angustifolia (Lavender) Oil, Citrus Aurantium Bergamia (Bergamot) Peel Oil\n",
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:45.802Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
